<div class="icon-buttons-container">
  <q9-icon-button
    [icon]="'move_up'"
    [disabled]="navigationParentDisabled && navigationPreviousDisabled && navigationParentDisabled"
    [matMenuTriggerFor]="navigationMenu"
    [matTooltip]="'Diagram navigation'"
    matTooltipPosition="below"></q9-icon-button>
  <mat-menu #navigationMenu="matMenu" class="q9-menu">
    <button
      mat-menu-item
      class="tool-btn"
      [disabled]="navigationTopDisabled"
      *q9Screenshot="screenConfig('top')"
      q9Track="TOOLBAR.NAVIGATE_HOME"
      (click)="goTop()">
      {{ 'Go to top diagram' }}
    </button>
    <button
      mat-menu-item
      class="tool-btn"
      [disabled]="navigationParentDisabled"
      *q9Screenshot="screenConfig('parent')"
      q9Track="TOOLBAR.NAVIGATE_UP"
      (click)="goToParent()">
      {{ 'Go to parent diagram' }}
    </button>
    <button
      mat-menu-item
      class="tool-btn"
      [disabled]="navigationPreviousDisabled"
      *q9Screenshot="screenConfig('previous')"
      q9Track="TOOLBAR.NAVIGATE_BACK"
      (click)="navigateToPrevious()">
      {{ 'Go to previous diagram' }}
    </button>
  </mat-menu>
  <q9-icon-button
    class="icon-button--last"
    [icon]="'small_arrow_down'"
    [matMenuTriggerFor]="navHistoryMenu"
    [ngStyle]="{'pointer-events': navigationPreviousDisabled ? 'none' : 'auto'}"
    [disabled]="navigationPreviousDisabled"
    [matTooltip]="'Navigation history'"
    matTooltipPosition="below"
    (click)="onHistoryMenu(); $event.stopPropagation()"></q9-icon-button>
</div>
<mat-menu #navHistoryMenu="matMenu" class="nav-history-container q9-menu">
  <button
    mat-menu-item
    *ngFor="let navItem of navHistoryList; index as i"
    matTooltip="{{ navItem.name | decodeHtml }}"
    matTooltipPosition="below"
    [matTooltipDisabled]="isTooltipDisabled(navItem)"
    (click)="navigateToNavHistoryItem(i)">
    <div class="nav-history-item">
      <div class="nav-history-item__name">{{ navItem.name | decodeHtml }}</div>
      <div class="nav-history-item__lvl">
        lvl. {{ navItem.levelNumber }}({{ navItem.state | diagramState }})
      </div>
    </div>
  </button>
</mat-menu>
